import { render, staticRenderFns } from "./SyncStatusDisplay.vue?vue&type=template&id=885af2fc&scoped=true&"
import script from "./SyncStatusDisplay.vue?vue&type=script&lang=js&"
export * from "./SyncStatusDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SyncStatusDisplay.vue?vue&type=style&index=0&id=885af2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885af2fc",
  null
  
)

export default component.exports